exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ljr-share-button-container .ljr-share-button{background-color:#363636;border-radius:4px;width:27px;height:25px;text-align:center;padding:0;border:0}.ljr-share-button-container .ljr-share-button>i{color:#fff;font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/commons/ShareButton/ShareButton.scss
// module id = 873
// module chunks = 0